class BrowserStorage {
  constructor() {
    this.prefix = 'codeMaps_';
  }

  async get(key) {
    try {
      const fullKey = `${this.prefix}${key}`;
      const stored = localStorage.getItem(fullKey);
      if (stored !== null) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error(`Error reading ${key} from localStorage:`, error);
    }
    return null;
  }

  async set(key, data) {
    try {
      const fullKey = `${this.prefix}${key}`;
      localStorage.setItem(fullKey, JSON.stringify(data));
      return true;
    } catch (error) {
      console.error(`Error writing ${key} to localStorage:`, error);
      return false;
    }
  }

  async remove(key) {
    try {
      const fullKey = `${this.prefix}${key}`;
      localStorage.removeItem(fullKey);
      return true;
    } catch (error) {
      console.error(`Error removing ${key} from localStorage:`, error);
      return false;
    }
  }
}

export const browserStorage = new BrowserStorage();
